import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "./translations";

const VALID_LANGS = ["fr", "en", "es"];
const LangContext = createContext({ lang: "fr", t: (k) => k, setLang: () => {} });

export function LangProvider({ children }) {
  const [state, setState] = useState(() => {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (param && VALID_LANGS.includes(param.toLowerCase()))
      return { lang: param.toLowerCase(), explicit: true, welcome: false };
    const saved = localStorage.getItem("igc_lang");
    if (saved && VALID_LANGS.includes(saved))
      return { lang: saved, explicit: true, welcome: false };
    return { lang: "fr", explicit: false, welcome: true };
  });

  const lang = state.lang;
  const t = (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.fr[key] ?? key;

  useEffect(() => {
    if (state.explicit) localStorage.setItem("igc_lang", lang);
    document.documentElement.lang = lang;
    document.title = t("page.title");
  }, [lang, state.explicit]);

  useEffect(() => {
    const onMessage = (e) => {
      if (e.data?.type === "CHANGE_LANGUAGE" && VALID_LANGS.includes(e.data.lang)) {
        setState((s) => ({ ...s, lang: e.data.lang, explicit: true, welcome: false }));
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const setLang = (l) => setState((s) => ({ ...s, lang: l, explicit: true, welcome: false }));

  return (
    <LangContext.Provider value={{ lang, t, setLang, showWelcome: state.welcome, closeWelcome: () => setState((s) => ({ ...s, welcome: false })) }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
